module.exports = __webpack_public_path__ + "img/ine-logo-black.77ddfc7c.png";